export default {
    path : "officebuilding-carrier-all",
    name : "officebuilding-carrier-all",
    meta : {
        title : "全部载体"
    },
    component: () => import('@/pages/officebuilding/allCarrier/Index'),
    redirect: {
        name : "officebuilding-carrier-all-whole"
    },
    children: [
        {
            path: 'all',
            name: 'officebuilding-carrier-all-whole',
            meta: {
                title: '写字楼载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'recent',
            name: 'officebuilding-carrier-all-recent',
            meta: {
                title: '写字楼载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'atme',
            name: 'officebuilding-carrier-all-atme',
            meta: {
                title: '写字楼载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'meat',
            name: 'officebuilding-carrier-all-meat',
            meta: {
                title: '写字楼载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'reply',
            name: 'officebuilding-carrier-all-reply',
            meta: {
                title: '写字楼载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'search',
            name: 'officebuilding-carrier-all-search',
            meta: {
                title: '写字楼载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path : 'detail/:id',
            name : 'officebuilding-carrier-all-detail',
            metal: {
                title : '项目详细信息',
            },
            component: () => import('@/pages/carrierCommon/Detail'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/officebuilding/allcarrier/index.js